import { render, staticRenderFns } from "./newsletterAS.vue?vue&type=template&id=f22dbe70"
import script from "./newsletterAS.vue?vue&type=script&lang=js"
export * from "./newsletterAS.vue?vue&type=script&lang=js"
import style0 from "./newsletterAS.vue?vue&type=style&index=0&id=f22dbe70&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports